import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidatePhone } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { AddressFieldDisplayModel } from "@insite/client-framework/Types/ApiModels";

type PlaceOrderProps = Parameters<typeof ValidatePhone>[0];

const phoneRegex = /^(1\s?)?[\s\-]?(\d{3}|\(\d{3}\))?[\s\-]?\d{3}[\s\-]?\d{4}$/;

const isEmpty = (value: string) => value.trim().length <= 0;
const isValidPhoneNumber = (value: string) => {
    const result = phoneRegex.test(value);
    return result;
};

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

function CustomValidatePhone(props: PlaceOrderProps) {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { phone } = props.parameter.address;
    if (addressFieldDisplayCollection.phone?.isVisible && validationRules.phone?.isRequired && isEmpty(phone)) {
        props.addressErrors.phone = getRequiredErrorMessage(addressFieldDisplayCollection.phone);
    } else if (!isEmpty(phone) && !isValidPhoneNumber(phone)) {
        props.addressErrors.phone = siteMessage("AddressInfo_Phone_Validation");
    }
}

replaceInChain(chain, ValidatePhone, CustomValidatePhone);
